/*=========================================================================================
  File Name: profileActions.js
  Description: Vuex Store - profile actions
==========================================================================================*/

import axios from 'axios';
import state from '../state';

export default {
    /**
     * update profile
     *
     * @param commit
     * @param payload
     * @returns {Promise<unknown>}
     */
    updateProfile({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios.defaults.headers.post['Content-Type'] = 'multipart/form-data';
            axios({url: state.API_URL + '/auth/profile/update', data: payload, method: 'POST'})
                .then(({data}) => {
                    if (data.web_request === null) {
                        if(payload.data.frontend_notify){
                            if(state.frontend_notify.title === false) {
                                state.frontend_notify.title = state.currentTranslations[data.message];
                                state.frontend_notify.type = 'success';
                            }
                        } else {
                            if(payload.notify) {
                                payload.notify({
                                    time: 3500,
                                    text: state.currentTranslations[data.message],
                                    iconPack: 'feather',
                                    icon: 'icon-check',
                                    color: 'success'
                                });
                            }
                        }


                        let update_data = {
                            payload: payload,
                            data: data,
                        };
                        commit('profile_updated', update_data);
                        resolve();
                    } else {
                        axios({url: data.web_request.url, data: {data: data, payload: payload}, method: 'POST'})
                            .then(({data}) => {
                                if(payload.frontend_notify){
                                    state.frontend_notify.title = state.currentTranslations[data.message];
                                } else {
                                    if(payload.notify) {
                                        payload.notify({
                                            time: 3500,
                                            text: state.currentTranslations[data.message],
                                            iconPack: 'feather',
                                            icon: 'icon-check',
                                            color: 'success'
                                        });
                                    }
                                }

                                commit('profile_updated', data.data);
                                resolve(data.data);
                            }).catch(({response}) => {
                            reject(response.data);
                        });
                    }
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },

    /**
     * change password
     *
     * @param commit
     * @param payload
     * @returns {Promise<unknown>}
     */
    changePassword({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/profile/change-password', data: payload, method: 'POST'})
                .then((response) => {
                    commit('password_change_success', response.data);
                    localStorage.removeItem('access-token');
                    delete axios.defaults.headers.common['Authorization'];
                    resolve();
                }).catch((error) => {
                commit('password_change_error', error.response.data);
                reject(error.response.data);
            })
        });
    },

    /**
     * change email
     *
     * @param commit
     * @param payload
     * @returns {Promise<unknown>}
     */
    changeEmail({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/profile/change-email', data: payload, method: 'POST'})
                .then((response) => {
                    commit('email_change_success', response.data);
                    localStorage.removeItem('access-token');
                    delete axios.defaults.headers.common['Authorization'];
                    resolve();
                }).catch((error) => {
                commit('email_change_error', error.response.data);
                reject(error.response.data);
            })
        });
    },

    /**
     *
     * send phone vverification
     *
     * @param commit
     * @param payload
     * @returns {Promise<unknown>}
     */
    verifyPhone({commit}) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/profile/verify-phone', method: 'POST'})
                .then(({data}) => {
                    commit('resend_phone_confirm_success', data);
                    resolve();
                }).catch(({response}) => {
                commit('resend_phone_confirm_error', response.data);
                reject(response.data);
            })
        });
    },

    /**
     * confirm phone verification
     *
     * @param commit
     * @param payload
     * @returns {Promise<unknown>}
     */
    verifyPhoneConfirm({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/profile/verify-confirm-phone', data: payload, method: 'POST'})
                .then(({data}) => {
                    commit('phone_confirm_success', data);

                    if(payload.notify) {
                        payload.notify({
                            time: 3500,
                            text: state.currentTranslations[data.message],
                            iconPack: 'feather',
                            icon: 'icon-check',
                            color: 'success'
                        });
                    }

                    resolve();
                }).catch(({response}) => {
                commit('phone_confirm_error', response.data);
                reject(response.data);
            })
        });
    },

    /**
     *
     * @param commit
     * @param payload
     * @returns {Promise<unknown>}
     */
    changePhone({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/profile/change-phone', data: payload, method: 'POST'})
                .then(({data}) => {
                    commit('phone_change_success', data);
                    resolve();
                }).catch(({response}) => {
                commit('phone_change_error', response.data);
                reject(response.data);
            })
        });
    },

    /**
     *
     * @param commit
     * @param payload
     * @returns {Promise<unknown>}
     */
    resendConfirmNewPhone({commit}) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/profile/resend-confirm-new-phone', method: 'POST'})
                .then(({data}) => {
                    commit('resend_phone_confirm_success', data);
                    resolve();
                }).catch(({response}) => {
                commit('resend_phone_confirm_error', response.data);
                reject(response.data);
            })
        });
    },

    /**
     * confirm any email related confirm
     *
     * @param commit
     * @param payload
     * @returns {Promise<unknown>}
     */
    confirmNewPhone({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/profile/confirm-new-phone', data: payload, method: 'POST'})
                .then(({data}) => {
                    commit('phone_confirm_success', data);

                    if(payload.notify) {
                        payload.notify({
                            time: 3500,
                            text: state.currentTranslations[data.message],
                            iconPack: 'feather',
                            icon: 'icon-check',
                            color: 'success'
                        });
                    }

                    resolve();
                }).catch(({response}) => {
                commit('phone_confirm_error', response.data);
                reject(response.data);
            })
        });
    },

    updateTwoFA({commit}, payload) {
        return new Promise((resolve) => {

            axios.post(state.API_URL + '/auth/profile/two-fa/update', payload).then(({data}) => {
                if(payload.notify) {
                    payload.notify({
                        time: 3500,
                        text: state.currentTranslations[data.message],
                        iconPack: 'feather',
                        icon: 'icon-check',
                        color: 'success'
                    });
                }

                commit('update_two_fa_success', payload);

                resolve();
            });
        });
    },

    updateNotifications({commit}, payload) {
        return new Promise((resolve) => {
            commit('update_notification_settings', payload);
            axios.post(state.API_URL + '/auth/profile/update-notification-settings', payload).then(({data}) => {
                if(payload.notify) {
                    payload.notify({
                        time: 3500,
                        text: state.currentTranslations[data.message],
                        iconPack: 'feather',
                        icon: 'icon-check',
                        color: 'success'
                    });
                }

                resolve();
            });
        });
    },
};
